var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.userToken)?_c('onboarding'):_vm._e(),(_vm.userToken)?_c('navbar',{attrs:{"open":_vm.isMobileNavOpen}}):_vm._e(),_c('mobile-nav',{on:{"open":_vm.setOpen}}),_c('div',{staticClass:"view-container",class:{
      'signed-in': _vm.userToken,
      'full-width': !_vm.showNavBar,
    },on:{"click":function($event){_vm.isMobileNavOpen = false}}},[_c('transition',{attrs:{"name":"slide-left"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }